/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to specify the status bar region in which a widget should be located.
 * <br><br>
 * @module MW/statusbar/RegionMixin
 *
 * @copyright Copyright 2018 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {

        region: "left",

        _setRegionAttr: function (value) {
            if (!(value === "left" || value === "right")) {
                throw new Error('region property must "left" or "right"');
            }
            this._set("region", value);
        }
    });
});

